
/* injects from baggage-loader */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import GoldenRaceSingles from './singles';
import GoldenRaceMultiple from './multiple';
import GoldenRaceSystem from './system';
import GoldenRaceSingle from './single';

const componentMap = {
    'Single': GoldenRaceSingle,
    'Singles': GoldenRaceSingles,
    'Multiple': GoldenRaceMultiple,
    'SystemMultiple': GoldenRaceMultiple,
    'System': GoldenRaceSystem,
};

const getBetsWithEvents = betInfo => {
    const winEvents = betInfo.win_info?.AdditionalInfo.details.events; // maybe this details also should be Uppercase Details

    return betInfo.AdditionalInfo.Details.events.reduce((acc, event) => {
        const winEvent = winEvents?.find(item => item.eventId === event.eventId);

        const betsInsideEvent = event.bets.map(bet => {
            const wonBet = winEvent?.bets.find(item => item.lineId === bet.lineId);
            return {
                ...bet,
                win_info: wonBet,
                win_event: winEvent ? _.omit(winEvent, 'bets') : null,
                event: _.omit(event, 'bets')
            };
        });

        return [...acc, ...betsInsideEvent];
    }, []);
};

const MultipleTicketsGoldenRace = ({ dataFromCasino }) => {
    const multiplyInfoList = useMemo(() => dataFromCasino.BetMultiplyInfo.map(item => ({
        allBets: getBetsWithEvents(item),
        betInfo: item,
    })), [dataFromCasino]);
    console.log('heheeheheehe', multiplyInfoList)
    return <>
        {multiplyInfoList.map(item => {
            const TicketView = componentMap[item.betInfo.AdditionalInfo.ticketType];
            return TicketView ? <div className="ticket-b-info-w-inside">
                <TicketView key={item.betInfo.TransactionId} {...item} />
            </div> : null;
        })}
    </>;
}

MultipleTicketsGoldenRace.propTypes = {
    dataFromCasino: PropTypes.object.isRequired,
};

export default MultipleTicketsGoldenRace;